import React, { lazy, Suspense, memo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchConstants } from 'store/slices/authSlice';
import Loading from 'components/shared-components/Loading';
import Views from 'views';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const auth = useSelector((state) => state.auth);
  const constants = useSelector((state) => state.auth.constants);
  console.log("auth", auth)
  console.log("TOKEN", token)
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const direction = useSelector((state) => state.theme.direction);
  const navType = useSelector((state) => state.theme.navType);
  const navCollapsed = useSelector((state) => state.theme.navCollapsed);

  useEffect(() => {
    // Fetch constants if not already loaded
    if (!constants && token) {
      dispatch(fetchConstants());
    }
  }, [dispatch, constants, token]);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  return (
    <Suspense fallback={<Loading cover='content' />}>
      <Layout
        direction={direction}
        navType={navType}
        navCollapsed={navCollapsed}
      >
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
